import { useState } from 'react';
import { Platform, Pressable, View } from 'react-native';

// A Pressable claims the JS responder with blockNativeResponder, so on phones
// the first finger movement cancels the native long-press that starts text
// selection. Phones get a plain View; only the Mac needs hover events.
const MessageContainer = Platform.OS === 'ios' || Platform.OS === 'android' ? View : Pressable;

// Touch devices always expose actions. Only Mac messages need hover reveal.
export default function useNativeMessageActions() {
  const [isHovered, setIsHovered] = useState(false);
  const isMac = Platform.OS === 'macos';
  return {
    MessageContainer,
    actionsVisible: !isMac || isHovered,
    hoverProps: isMac ? {
      onHoverIn: () => setIsHovered(true),
      onHoverOut: () => setIsHovered(false),
    } : {},
  };
}
